import api from ".";
import cookiesModifier from "../utils/cookies";

import { ICombinedScoreHypo } from "../types/scoreHypo";

export const getAllScoreHypo = async (userId: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`score-hypo-groups/applicant/${userId}`);
        return res.data as ICombinedScoreHypo;
    } catch (error) {
        throw error;
    }
}